module.exports = __webpack_public_path__ + "img/SEG-min.e513d029.png";